<template>
  <div class="item-list">
    <press-item
      v-for="item in data"
      :key="item.ID"
      :publish="item.Publish"
      :date="item.Date"
      :medium="item.Medium"
      :format="item.Category"
      :title="item.Title"
      :link="item.URL"
      :project1="item.Reference1"
      :project2="item.Reference2"
      :AW_AWCH="AW_or_and_AWCH"
      :paywall="item.paywall"
      :crosspost="item.crosspost"
      :langLabel="item.Language_ISO2"
    ></press-item>
  </div>
</template>


<script>
import PressItem from "../Press/PressItem.vue";

export default {
  components: {
    PressItem,
  },
  props: {
    data: {
      type: Array,
      default: () => {},
      required: true,
    },
  },
};
</script>

<style scoped>
.events-list {
  /* max-width: 50rem; */
  /* margin: auto; */
}

h3 {
  margin: 40px 0 0 !important;
}
ul {
  list-style-type: none !important;
  padding: 0 !important;
}
li {
  display: inline-block !important;
  margin: 0 10px !important;
}
a {
  color: #428bfa !important;
  text-decoration: none !important;
}
a:hover {
  text-decoration: underline !important;
}
</style>